import { api } from "./api";
import { getElement, trackUnsavedInput } from "./generics";

const form           = getElement<HTMLFormElement>("contact-form");
const categorySelect = getElement<HTMLSelectElement>("contact-category");
const messageInput   = getElement<HTMLTextAreaElement>("contact-message");
const messageError   = getElement<HTMLSpanElement>("contact-message-error");
const emailInput     = getElement<HTMLInputElement>("contact-email");
const submitBtn      = form.querySelector<HTMLButtonElement>("button[type=submit]")!;
const feedback       = getElement<HTMLParagraphElement>("contact-feedback");

trackUnsavedInput(messageInput);

// Ile trwa "Dziękujemy, wiadomość wysłana" na ekranie, zanim sam zniknie - bez tego zostawał tam
// bezterminowo, aż ktoś wyśle kolejną wiadomość (patrz feedbackHideTimer niżej).
const FEEDBACK_HIDE_MS = 10000;
let feedbackHideTimer: ReturnType<typeof window.setTimeout> | undefined;

form.addEventListener("submit", async (event: Event) => {
    event.preventDefault();
    if (feedbackHideTimer !== undefined) window.clearTimeout(feedbackHideTimer);
    messageError.textContent = "";
    feedback.textContent = "";

    const message = messageInput.value.trim();
    if (message.length < 5) {
        messageError.textContent = "Wiadomość musi mieć co najmniej 5 znaków.";
        return;
    }

    submitBtn.disabled = true;
    feedback.textContent = "Wysyłanie...";

    const result = await api.sendContactMessage({
        category: categorySelect.value,
        message,
        email: emailInput.value.trim(),
    });

    if (result.ok) {
        feedback.textContent = result.data.textmessage;
        form.reset();
        feedbackHideTimer = window.setTimeout(() => {
            feedback.textContent = "";
        }, FEEDBACK_HIDE_MS);
    } else {
        feedback.textContent = `Błąd: ${result.error}`;
    }
    submitBtn.disabled = false;
});
